export default {
  title: 'ชำระค่าจอดรถ',
  // check-in kiosk
  check_in_title: 'ลงทะเบียนเข้าจอด',
  check_in_subtitle: 'กรอกทะเบียนรถเพื่อลงทะเบียน รูปถ่ายไม่จำเป็น',
  license_plate_label: 'ทะเบียนรถ',
  license_plate_placeholder: 'เช่น 1กก 1234',
  photo_label: 'รูปรถ (ไม่จำเป็น)',
  tap_to_capture: 'แตะเพื่อถ่ายรูป',
  retake_photo: 'ถ่ายใหม่',
  check_in_submit: 'เข้าจอด',
  checking_in: 'กำลังลงทะเบียน…',
  // pay page
  checked_in_at: 'เข้าจอดเมื่อ {{time}}',
  checked_in_subtitle: 'เมื่อพร้อมออก แตะด้านล่างเพื่อชำระเงิน',
  pay_now: 'ฉันกำลังออก ชำระเงินเลย',
  preparing_payment: 'กำลังเตรียมการชำระเงิน…',
  tap_to_refresh: 'แตะเพื่อตรวจสอบสถานะ',
  scan_qr_to_pay: 'สแกนเพื่อชำระเงิน',
  scan_dynamic_qr: 'สแกนเพื่อชำระเงินด้วย พร้อมเพย์',
  reference_label: 'อ้างอิง',
  charge_amount: 'ยอดชำระ: ฿{{amount}}',
  upload_slip: 'อัปโหลดสลิปการชำระเงิน',
  upload_slip_locked: 'อัปโหลดสลิป (ถ่ายรูปรถก่อน)',
  remove_slip: 'เอารูปสลิปออก',
  tap_to_upload: 'แตะเพื่อเลือกรูปสลิป',
  submit_slip: 'ส่งสลิป',
  slip_submitted: 'ส่งสลิปแล้ว',
  waiting_title: 'ส่งสลิปแล้ว',
  waiting_subtitle: 'กำลังตรวจสอบสลิป หน้านี้จะอัปเดตอัตโนมัติ',
  upload_new_slip: 'อัปโหลดสลิปใหม่',
  paid_title: 'ยืนยันการชำระแล้ว',
  paid_subtitle: 'ยืนยันเมื่อ {{time}} ขับรถปลอดภัย!',
  // EP-161 S3a: the live car photo before the slip
  car_photo: {
    step_title: 'ถ่ายรูปรถให้เห็นทะเบียนและจุดที่จอด',
    open_camera: 'เปิดกล้อง',
    camera_title: 'ถ่ายรูปรถของคุณ',
    hint: 'ให้เห็นทะเบียนและจุดที่จอด',
    asking: 'กำลังเปิดกล้อง',
    shutter: 'ถ่าย',
    retake: 'ถ่ายใหม่',
    captured_alt: 'รูปรถที่ถ่ายไว้',
    uploading: 'กำลังส่งรูปรถ',
    refused_title: 'ต้องเปิดกล้องเพื่อถ่ายรูปรถ',
    refused_iphone: 'iPhone: แตะ aA ที่แถบที่อยู่ เลือกการตั้งค่าเว็บไซต์ แล้วตั้งกล้องเป็นอนุญาต',
    refused_android: 'Android: แตะไอคอนหน้าที่อยู่เว็บ เลือกสิทธิ์ แล้วอนุญาตกล้อง',
    retry: 'ลองเปิดกล้องอีกครั้ง',
  },
  // EP-161 S3: rejected slip
  rejected_title: 'สลิปไม่ผ่านการตรวจสอบ',
  rejected_reason: 'เหตุผล: {{reason}}',
  rejected_plate: 'ทะเบียน {{plate}}',
  rejected_resubmit: 'ส่งสลิปใหม่',
  rejected_contact_staff: 'หรือติดต่อเจ้าหน้าที่ที่ป้อมยาม',
  // EP-161 §10 item 17: slip_upload answered contact_staff
  contact_staff_title: 'ติดต่อเจ้าหน้าที่ที่ป้อมยาม',
  contact_staff_subtitle: 'เจ้าหน้าที่จะช่วยดำเนินการชำระค่าจอดรถให้',
  overstay_title: 'กรุณาติดต่อเจ้าหน้าที่เพื่อออกจากที่จอด',
  overstay_subtitle: 'รถของคุณจอดเกินช่วงเวลาชำระเงินอัตโนมัติแล้ว เจ้าหน้าที่จะช่วยดำเนินการชำระเงิน',
  errors: {
    invalid_token: 'ลิงก์ชำระเงินไม่ถูกต้องหรือหมดอายุ',
    invalid_apikey: 'ลิงก์ลงทะเบียนเข้าจอดไม่ถูกต้องหรือหมดอายุ',
    load_failed: 'โหลดข้อมูลไม่สำเร็จ กรุณาลองอีกครั้ง',
    upload_failed: 'อัปโหลดไม่สำเร็จ กรุณาลองอีกครั้ง',
    checkout_failed: 'ไม่สามารถเริ่มการชำระเงินได้ กรุณาลองอีกครั้ง',
    no_file: 'กรุณาเลือกรูปภาพ',
    no_plate: 'กรุณากรอกทะเบียนรถ',
    check_in_failed: 'ลงทะเบียนเข้าจอดไม่สำเร็จ กรุณาลองอีกครั้ง',
    location_photo_stale: 'รูปนี้นานเกินไป ถ่ายใหม่อีกครั้ง',
    location_photo_required: 'ถ่ายรูปรถก่อนส่งสลิป',
    capture_failed: 'ถ่ายรูปไม่สำเร็จ กรุณาลองอีกครั้ง',
  },
}
